var _a, _b, _c, _d;
import { __decorate, __metadata } from "tslib";
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Actions, Mutations } from '@/store/enums/hrgs/assessment/ApprovalHistoryEnums';
import ApiService from '@/core/services/ApiService';
import { hrgsSwalAlert } from '@/core/helpers/sweet-alert';
import { Pagination } from '@/core/enums/Pagination';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_MOBA_WEBAPI}`;
const API_URLS = {
    url: `${API_URL}/api/approvals`
};
let ApprovalHistoryModule = class ApprovalHistoryModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.approvalHistoryList = [];
        this.loading = false;
        this.pagination = {
            totalPage: 0,
            totalPageSize: 0,
            startPaginationIndex: 0,
            endPaginationIndex: 0,
            currentPage: 1
        };
    }
    // *GETTERS
    get getApprovalHistoryList() {
        return this.approvalHistoryList;
    }
    get getApprovalHistoryListLoading() {
        return this.loading;
    }
    get getApprovalHistoryListPagination() {
        return this.pagination;
    }
    // *MUTATIONS
    [_a = Mutations.SET_LIST](data) {
        this.approvalHistoryList = data;
    }
    [_b = Mutations.SET_LIST_LOADING](data) {
        this.loading = data;
    }
    [_c = Mutations.SET_LIST_PAGINATION](data) {
        const totalPage = data.totalItems || 0;
        const totalPageSize = data.pageSize || this.pagination.totalPageSize;
        const currentPage = data.currentPage || this.pagination.currentPage;
        this.pagination = {
            totalPage,
            totalPageSize,
            currentPage,
            startPaginationIndex: 0,
            endPaginationIndex: Math.floor(totalPage / totalPageSize)
        };
    }
    // *start: ACTION
    [_d = Actions.GET_LIST](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            hrgsSwalAlert({ icon: 'error', text: 'Employee ID tidak ditemukan.' });
            return false;
        }
        const params = {
            ver: 'v1',
            pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE,
            pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO,
            assessmentId: payload.assessmentId
        };
        this.context.commit(Mutations.SET_LIST_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/histories/?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                this.context.commit(Mutations.SET_LIST, resData.data);
                this.context.commit(Mutations.SET_LIST_PAGINATION, {
                    currentPage: params.pageNo,
                    pageSize: params.pageSize,
                    totalItems: resData.totalRecords
                });
                resolve(resData.data);
            })
                .catch((error) => {
                hrgsSwalAlert({ icon: 'error', text: 'Failed get list.' });
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_LIST_LOADING, false);
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ApprovalHistoryModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ApprovalHistoryModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ApprovalHistoryModule.prototype, _c, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ApprovalHistoryModule.prototype, _d, null);
ApprovalHistoryModule = __decorate([
    Module
], ApprovalHistoryModule);
export default ApprovalHistoryModule;
